module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1030-cf1215a6f61ba38ef9db8c0131af8e49.png";